$(document).ready(function() {

	/* ========================================== 
	Sticky header & support bar
	========================================== */
	$(window).scroll(function() {
		if ($(window).scrollTop() >= 1) {
			$('#header').addClass('fixed');
		} else {
			$('#header').removeClass('fixed');
		}

	});

	/* ========================================== 
	Navigation open/close functions
	========================================== */
	$('.navbar-toggler').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('body').toggleClass('nav-open');
	});
	$(document).keydown(function(e) {
		if (e.keyCode == 27) {
			$('body').removeClass('nav-open');
		}
	});
	$(document).mouseup(function(e) {
		var container = $(".main-menu");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('body').removeClass('nav-open');
		}
	});

	// First click show dropdwon and on second click go to url
	$('a[data-toggle="dropdown"]:not([href=""])').off('click.namespace').on('click.namespace', function(e) {
		if ($(this).parent().is('.show, .open')) window.open($(this).attr('href'), $(this).attr('target') || '_self');
	});

	/* ========================================== 
	Add div background image
	========================================== */
	$('.gallery .image-holder').each(function(i, obj) {
		var getImageSrc = $(obj).find('img').attr('src');
		$(obj).find('a').css('background-image', 'url(' + getImageSrc + ')');
	});
  
  $(".product-gallery--navigation button").click(function(){  	
   
    var mdata = $(this).attr('data-media');
     //console.log("cl"+mdata);
    
    console.log($(this).parent().prev().attr('class'));
    
    
    $(this).parent().prev().children('figure').attr("data-product-gallery-selected","false");
    $(this).parent().prev().children('figure').attr("aria-hidden","true");
    
//     $('.product-gallery--viewport figure').attr("data-product-gallery-selected","false");
//     $('.product-gallery--viewport figure').attr("aria-hidden","true"); 
    
    $('.product-gallery--viewport figure').each(function(index,val){
      
       var kdata = $(this).attr('data-media');
       //console.log(kdata);      
      
      if(mdata==kdata){
        
         $(this).attr("data-product-gallery-selected","true");
    	 $(this).attr("aria-hidden","false");
         $(this).addClass('zoom-enabled');
         var mainimg = $(this).attr('data-image-zoom-src');      	
         $(this).find('.product-gallery--image-zoom-container').css("background-image", "url("+mainimg+")");
        
      }
   
    });
  
  });
  
  
});

/* ========================================== 
	Set Height of main section
	========================================== */
$(window).bind("load resize scroll", function() {
	$(function() {
	});
});